import axios from "axios";
import { getApiUrlWithVersion } from "./environmentService";
import { getAuthUser } from "./authService";

const getAuthHeaders = () => ({ Authorization: getAuthUser()?.accessToken });

export const getOrgUsers = async () => {
  const response = await axios.get(
    `${getApiUrlWithVersion()}/organization/users`,
    { headers: getAuthHeaders() });

  return response.data;
}

export const getOrgInvitations = async () => {
  const response = await axios.get(
    `${getApiUrlWithVersion()}/organization/invitations`,
    { headers: getAuthHeaders() }
  );

  return response.data;
}

export const inviteOrgUser = async (email: string) => {
  const response = await axios.post(
    `${getApiUrlWithVersion()}/organization/invitations`,
    { email },
    { headers: getAuthHeaders() }
  );

  return response.data;
}

export const deleteOrgInvitation = async (invitationId: string) => {
  const response = await axios.delete(
    `${getApiUrlWithVersion()}/organization/invitations/${invitationId}`,
    { headers: getAuthHeaders() }
  );

  return response.data;
}

export const getOrgUser = async (userId: string) => {
  const response = await axios.get(
    `${getApiUrlWithVersion()}/organization/users/${userId}`,
    { headers: getAuthHeaders() }
  );

  return response.data;
}

export const getPrimaryBlueprint = async () => {
  const response = await axios.get(
    `${getApiUrlWithVersion()}/organization/primary_blueprint`,
    { headers: getAuthHeaders() }
  );
  return response.data;
}

export const setPrimaryBlueprint = async (blueprintId: number | null) => {
  const response = await axios.put(
    `${getApiUrlWithVersion()}/organization/primary_blueprint`,
    { blueprint_id: blueprintId },
    { headers: getAuthHeaders() }
  );
  return response.data;
}

export const updateOrgUser = async (userId: string, updates: { receive_content_plan_emails?: boolean; content_interview_email_frequency?: string; content_interview_email_day?: number | null; receive_approval_emails?: boolean; active?: boolean }) => {
  const response = await axios.patch(
    `${getApiUrlWithVersion()}/organization/users/${userId}`,
    updates,
    { headers: getAuthHeaders() }
  );

  return response.data;
}
